<template>
  <div>
    <q-breadcrumbs class="q-mb-md">
      <q-breadcrumbs-el label="Home" icon="home"></q-breadcrumbs-el>
      <q-breadcrumbs-el :label="$t('breadcrumbs.groups.pagestudent')" icon="supervisor_account"></q-breadcrumbs-el>
    </q-breadcrumbs>

    <!--   PAGE IS LOADING:: -->
    <div class="row justify-center" v-if="loading">
      <div class="col-auto text-center">
        <q-spinner color="primary" size="64"/>
        <br>
        <small>
          {{$t('groups.retrieve_groups.cardtitle')}}
        </small>
      </div>
    </div>

    <!--  PAGE IS NOT LOADING::  -->
    <q-card class="bg-white" v-else>
      <q-card-section class="bg-primary row text-white justify-between q-pb-sm">
        <div class="text-h6">{{$t('groups.title.cardtitle')}}</div>

        <div class="row">
            <q-input class="bg-white q-pa-xs" style="border-radius: 4px"
                     v-model="searchModel"
                     :debounce="100"
                     dense
                     float-label
                     data-cy="groups-search-bar"
                     label="Zoeken"
                     autocomplete="off">
              <template v-slot:prepend>
                <q-icon name="search"/>
              </template>
            </q-input>
        </div>
      </q-card-section>

      <q-table :data="groups" :columns="columns" row-key="label" :pagination.sync="pagination">
        <q-tr slot="body" slot-scope="props" :props="props" :data-cy="'group-' + props.row.label">
          <q-td @click.native="onRowClick(props.row)" class="cursor-pointer">
            {{ props.row.label }}
            <q-icon v-if="props.row.imported" name="sync"></q-icon>
          </q-td>

          <q-td>
            <table-actions :config="actionsConfig" :item="props.row" :props="props"></table-actions>
          </q-td>

        </q-tr>
      </q-table>
    </q-card>

  </div>
</template>

<script>
  import { QBreadcrumbs, QBreadcrumbsEl, QCard, QCardSection, QIcon, QInput, QSpinner, QTable, QTd, QTr } from 'quasar'
  import { TableActions } from '@parantion/components'

  export default {
    components: {
      QCard,
      QCardSection,
      QSpinner,
      QInput,
      QBreadcrumbs,
      QBreadcrumbsEl,
      QTable,
      QTd,
      QTr,
      TableActions,
      QIcon
    },
    methods: {
      onRowClick (row) {
        this.goToGroup(row)
      },
      goToGroup (group) {
        this.$router.push({ path: '/groups/students/' + group.name })
      }
    },
    watch: {
      translationState () {
        this.columns = createColumns(this.$t)
      }
    },
    computed: {
      groups () {
        let groups = this.$store.state.groups.groups

        if (this.searchModel) groups = groups.filter(g => g.label.toLowerCase().includes(this.searchModel.toLowerCase()))

        groups = groups.filter(group => group.member === 0)
        if (!this.searchModel && groups.length === 1) {
          this.goToGroup(groups[0])
        }
        const importedGroupNames = this.$store.state.import.groups.map(g => g.name)

        return groups.map(group => {
          group.imported = importedGroupNames.includes(group.name)
          return group
        })
      }
    },
    created () {
      this.loading = true
      Promise.all([this.$store.dispatch('groups/retrieveGroups'), this.$store.dispatch('import/retrieveGroups')]).then(values => {
        this.loading = false
      })
    },
    data () {
      return {
        searchModel: '',
        translationState: this.$getTranslationOptions(),
        columns: createColumns(this.$t),
        loading: false,
        pagination: {
          sortBy: 'label', // String, column "name" property value
          descending: false,
          page: 1,
          rowsPerPage: 15 // current rows per page being displayed
        },
        actionsConfig: {
          primary: {
            icon: 'group',
            tooltip: 'tooltip.gotogroup.1',
            handler: (item) => {
              this.goToGroup(item)
            }
          },
          actions: []
        }
      }
    }
  }

  function createColumns ($t) {
    return [
      {
        label: $t('studenttable.name.label'),
        field: 'label',
        sortable: true,
        name: 'label',
        align: 'left'
      },
      {
        label: $t('studenttable.actions.label'),
        classes: 'action-column',
        name: 'actions',
        field: 'message',
        width: '200px'
      }
    ]
  }
</script>

<style>
  .modal-footer {
    box-shadow: none;
  }

  #group-table tr {
    cursor: pointer;
  }

</style>
